import { FormGroup, InputGroup } from '../Input'
import { Tooltip } from '../ToolTip'
import React, { useState } from 'react'
import { Icon, Intent, Position } from '@blueprintjs/core'
import { Button } from '../Button'
import { gql } from '@apollo/client'
import { useQuery } from '../../Hooks/graphql_utils'
import { useDebounce } from '../../Hooks/debounce'
import { Spinner } from '../Loader'
import { useNavigate } from 'react-router'

const QUERY = gql`
    query proNavQuery ($id: ID!) {
        job(id: $id) {
            id
            sub_jobs {
                id
                job_category {
                    id
                    name
                }
            }
        }
        lookupPoolType {
            id
            name
        }
    }
`

export const DailyBatchesProNav = ({ ...props }) => <ProNav
    navType='daily-batches'
    {...props}
/>

export const DailyYardageProNav = ({ ...props }) => <ProNav
    navType='daily-yardage'
    {...props}
/>

export const ProNav = ({ disabled, label, navType, errorText, groupStyles = {}, ...props }) => {
    const [proNavKeyword, setProNavKeyword] = useState(null)
    const debouncedKeyword = useDebounce(proNavKeyword, 500)
    const navigate = useNavigate()

    const { data, loading } = useQuery(QUERY, {
        variables: {
            id: debouncedKeyword || ''
        }
    })

    const targetJobId = data?.job?.id

    const tooltipContent = proNavKeyword 
        ? `No valid destination for '${proNavKeyword}'`
        : 'Please enter a Job Number'

    const buttonOnClick = () => {
        if (navType && targetJobId)
            navigate(`/${navType}/${targetJobId}`)
    }

    return (
        <FormGroup
            disabled={disabled}
            label={label}
            helperText={errorText || props.helpText}
            intent={errorText ? Intent.DANGER : Intent.NONE}
            style={{ margin: '1em 0 1em .25em', ...groupStyles }}
        >
            <InputGroup
                id='proNav'
                placeholder='...'
                value={proNavKeyword}
                onChange={(evt) => setProNavKeyword(evt.target.value)}
                rightElement={<Button minimal intent={Intent.PRIMARY} disabled={loading || !targetJobId} onClick={buttonOnClick}>
                    {loading
                        ? <Spinner size={10} />
                        : <Tooltip
                            content={tooltipContent}
                            position={Position.BOTTOM}
                            disabled={targetJobId}>
                            <Icon
                                color={!debouncedKeyword
                                    ? 'grey'
                                    : targetJobId
                                        ? 'blue'
                                        : 'indianRed'}
                                icon={!debouncedKeyword || targetJobId
                                    ? 'double-chevron-right'
                                    : 'issue'
                                } />
                        </Tooltip>
                    }
                </Button>}
            />
        </FormGroup>
    )
}